
import React from 'react';
import { StoreStation } from './StoreStation';

interface StoreStationEntryProps {
  onBack: () => void;
}

export const StoreStationEntry = ({ onBack }: StoreStationEntryProps) => {
  return <StoreStation onBack={onBack} />;
};
